import { render, staticRenderFns } from "./channelsConfig.vue?vue&type=template&id=3ea4680c&scoped=true"
import script from "./channelsConfig.vue?vue&type=script&lang=js"
export * from "./channelsConfig.vue?vue&type=script&lang=js"
import style0 from "./channelsConfig.vue?vue&type=style&index=0&id=3ea4680c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4680c",
  null
  
)

export default component.exports